// extracted by mini-css-extract-plugin
module.exports = {"categories":"categories__D7uS0","category":"category__s37D0","title":"title__1_5-X","description":"description__1SzDG"};